/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import * as API from "../../http/api";
import * as FUNC from "../../functions/functions";
import * as Modals from "./../modals";
import { openlightbox } from "../../util/Functions";
import { CustomerCancel, CustomerBlockUnblock, AfbUpdateCRM } from "./../modals";
import { Cancel, Download, Edit, Restore, ErrorOutline, Person, TrendingUp, PostAdd, NoteAdd, ContactPageSharp, LockReset, Description, Store } from "@mui/icons-material";
import { IconButton, Tooltip, Typography } from "@mui/material";
import { useStyles } from "../../util/ComponentStyles"
import moment from "moment";
import "moment/locale/es";
import Agreements from "../modals/agreements";
import { useDialog } from '@albo-ui/core'
import { rolesType, menuType, categoryMenu } from '../../util/DataObject';
import { IAgreementsUpdatePayload } from "../modals/agreements/common/agreementsReponse";
import { SimpleSnackbar } from "../elements";
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import GeneralConfirmDialog from "../modals/confirm/GeneralConfirmDialog";
import { useVipValidation } from "./customer-vip/hooks/useVipValidation";

const InfoPersonal = (props) => {
  const { onHandleValidate } = useVipValidation(props.changeAlert);
  moment.locale("es");
  const clasess = useStyles();
  const [content, setContent] = useState({
    uuid: "",
    name: "",
    status: "",
    risk: "",
    watchlist: "",
    watchlist_url: "",
    dateCheck: "",
    profileTransact: "",
    bdate: "",
    bstate: "",
    gender: "",
    occupation: "",
    email: "",
    phone: "",
    gname: "",
    lname: "",
    slname: "",
    taxid: "",
    bcountry: "",
    populationid: "",
    typeIdentity: "",
    front_image: "",
    statusValidation: "",
    email_verify: "",
    pep: "",
  });

  const [ocupacion, setOcupacion] = useState("");
  const [country, setCountry] = useState("");
  const [roles, setRoles] = useState([]);
  const [stateLabel, setStateLabel] = useState({
    gender: "",
    bstate: "",
  });
  const [blocked, setBlocked] = useState(false);
  const [blockCancel, setBlockCancel] = useState(false);

  const [upgrade, setUpgrade] = useState(false);
  const [catalogLevel, setCatalogLevel] = useState([]);
  const [level, setLevel] = useState("");
  const [type, setType] = useState("");
  
  const legacy = [
    { key: "state", label: "Estado" },
    { key: "country", label: "País" },
  ];
  
  const history = useHistory();
  const dialogProps = useDialog()
	const [updateData, setUpdateData] = useState(null);
  const [show, setShow] = useState(false);

	const onCloseDialog = () => {
    dialogProps.onClose()
    setUpdateData(null)
  }

  const dialogRisk = useDialog();
  const [element, setElement] = useState(null);
  const [dialogText, setDialogText] = useState({});
  const [item, setItem] = useState(null);
  const [segments, setSegments] = useState(null);
  const [companyGroups, setCompanyGroups] = useState(null);

  const config = localStorage.config && JSON.parse(localStorage.config);

  useEffect(() => {
    let rol = localStorage.config && JSON.parse(localStorage.config)['idRol'] ? [JSON.parse(localStorage.config)['idRol']] : [];
    setRoles(rol);
    if (props.content.status === "blocked") {
      setBlocked(true);
    } else {
      setBlocked(false);
    }
    if (props.content.status === "disabled") {
      setBlockCancel(true);
    } else {
      setBlockCancel(false);
    }

    let labelGender = "";
    let labelBstate = "";
    for (let i = 0; i < props.catalogs.gender.length; i++) {
      if (props.catalogs.gender[i]["k"] == props.content.gender) {
        labelGender = props.catalogs.gender[i]["v"];
      }
    }
    for (let i = 0; i < props.catalogs.states.length; i++) {
      if (props.catalogs.states[i]["k"] == props.content.bstate) {
        labelBstate = props.catalogs.states[i]["v"];
      }
    }

    if (props.content.originAppUUID === "3") {
      onGetSegments();
      onGetCompanyGroups();

      for (let i = 0; i < props.catalogs.economicActivities.length; i++) {
        if ( props.catalogs.economicActivities[i]["k"] == props.content.occupation) {
          setOcupacion(props.catalogs.economicActivities[i]["v"]);
        }
      }
    } else {
      for (let i = 0; i < props.catalogs.occupations.length; i++) {
        if (props.catalogs.occupations[i]["k"] == props.content.occupation) {
          setOcupacion(props.catalogs.occupations[i]["v"]);
        }
      }
    }

    for (let i = 0; i < props.catalogs.country.length; i++) {
      if (props.catalogs.country[i]["k"] == props.content.bcountry) {
        setCountry(props.catalogs.country[i]["v"]);
      }
    }

    setStateLabel({
      gender: labelGender,
      bstate: labelBstate,
    });

    if (props.config?.fields) {
      dataWidget();
    }

    if(props.content.subproduct_uuid){
      setType(props.content.subproduct_uuid?.split('-')[2])
    }
    if(props.content.subproduct){
      setType(props.content.subproduct?.split('-')[2])
    }

    hasAction("openIdentity") && props.content["typeIdentity"] && props.content.typeIdentity !== "Sin Documentos" && addIdentity(props.content.uuid);
  }, [props.content]);

  const dataWidget = async () => {
    let x = await FUNC.filter(props.content, props.config.fields.in);
    x = await FUNC.exclude(x, props.config.fields.ex);
    setContent(JSON.parse(JSON.stringify(x)));

    if(x['subproduct_uuid']){
      setLevel(x['subproduct_uuid'])      
    }
  };
  const hasAction = (action) => {
    return props.config?.actions?.indexOf(action) > -1;
  };
  const hasField = (field) => {
    return props?.["config"]?.fields?.only?.indexOf(field) > -1;
  };
  const hasFieldIn = (field) => {
    return props?.["config"]?.fields?.in?.indexOf(field) > -1;
  };
  const copy = (data) => {
    navigator.clipboard.writeText(data);
    setShow(true)
    setTimeout(() => {
      setShow(false);
    }, 1000);
  };

  const validation = async (data, type) => {
    let payload = {
      customerUuid: props.content.uuid, //TWO_FACTOR_AUTH
    };
    props.changeLoader(true);

    let request = await API.service('openModalUpdateProfile', payload, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == 'OK') {
      if(request.data.data.content){
        if(request.data.data.content.type == '2FA' || request.data.data.content.type == '1FA'){
          let factors = localStorage.factors ? JSON.parse(localStorage.factors) : {};
          factors[props.content.uuid] = request.data.data.content.uuid_factor;
          localStorage.factors = JSON.stringify(factors);
        }
        const as = <Modals.Factor
          intent="openModalUpdateProfile"
          contentModal={request.data.data.content}
          pos={props.pos}
          changeAlert={props.changeAlert}
          changeLoader={props.changeLoader}
          history={history}
          key="factor"
        />
        openlightbox(as);
      }else{
        viewEdit(data, type);
      }
    }
    props.changeLoader(false);
  };

  const dataReuse = async (uuid) => {
    props.changeLoader(true);

    let user = JSON.parse(localStorage.session);
    let data = {
      aql: `from data_reuse where customer_uuid=${uuid}`,
      agent: user["uuid"]
    }

    let request = await API.service( "alboQueryLanguaje", data, props.pos, props.changeAlert, props.changeLoader, history );

    if (request.status === 200 && request.data.data.response === "OK") {
      props.changeAlert(true, "success", "Los datos del cliente fueron liberados exitosamente");
    } else {
      let detail = request.data.data.message;
      props.changeAlert(true, "error", "Error al ejecutar consulta: " + detail);
    }
    props.changeLoader(false);
  };

  const resetPin = async (content) => {
    props.changeLoader(true);

    let data = {
      session: {
        email: content.email,
        action: "resetpin"
      }
    }
    if(type === 'n3'){
      data.session['phone'] = content.phone
    }

    let request = await API.service( "resetPin", data, props.pos, props.changeAlert, props.changeLoader, history );

    if (request.status === 200 && request.data.data.response === "OK") {
      props.changeAlert(true, "success", "El link para recupero de contraseña se envió correctamente");
    } else {
      let detail = request.data.data.message;
      props.changeAlert(true, "error", "Error al ejecutar proceso: " + detail);
    }
    props.changeLoader(false);
  };

  const reloadData = async (uuid) => {
    props.changeLoader(true);
    let find = {
      data: {
        customer: {
          keyword: uuid
        },
        filters: {
          results_per_page: 50,
          page_number: 1,
          search_type: "uuid"
        }
      }
    }

    let request = await API.service('dataPersonal', find, props.pos, props.changeAlert, props.changeLoader, history);
    if(request.status == 200 && request.data.data.response == 'OK'){
      let widg = request.data.data.widget;
      await props.changeWidgets(JSON.parse(JSON.stringify(widg)));
    }
    props.changeLoader(false);
  }

  const viewEdit = (data, type) => {
    const as = (
      <Modals.InfoPersonal
        contentModal={{
          general: data,
          title: "Editar datos personales",
          catalogs: props.catalogs,
          changeWidgets: props.changeWidgets,
          widgets: props.widgets,
        }}
        changeUpdate={props.changeUpdate}
        pos={props.pos}
        changeAlert={props.changeAlert}
        changeLoader={props.changeLoader}
        reloadData={reloadData}
        key="address"
      />
    );
    openlightbox(as);
  };

  const download = async (uuid, origin) => {
    props.changeLoader(true);
    if (hasFieldIn(origin)) {
      let payload = {
        customer_uuid: uuid
      };

      let request = await API.service( "afbOnboardingRecord", payload, props.pos, props.changeAlert, props.changeLoader, history);      
      if (request.status == 200 && request.data.data.response == "OK") {
        if(request.data.data.content["url"]){
          window.open(request.data.data.content["url"], "_blank")
        }else{
          props.changeAlert(true, 'error', 'El cliente no posee expediente.');
        }
      }
    } else {
      let payload = {
        customerUuid: uuid, //TWO_FACTOR_AUTH
      };
      let request = await API.service( "downloadInfo", payload, props.pos, props.changeAlert, props.changeLoader, history);
      if (request.status == 200 && request.data.data.response == "OK") {
        if(request.data.data.files[0] == 'sync'){
          props.changeAlert(true, 'success', 'Se esta generando el expediente');
        }else{
          window.open(request.data.data.files[0], "_blank")
        }
      }
    }
    props.changeLoader(false);
  };

  const addIdentity = async (uuid) => {
    props.changeLoader(true);

    let request = await API.service( "addIdentity", uuid, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == "OK") {
      let newWidgets = [];
      let existe = false;
      for (let i = 0; i < props.widgets.length; i++) {
        if (props.widgets[i]["type"] == "identity") {
          newWidgets.push(request.data.data.widget[0]);
          existe = true;
        } else {
          newWidgets.push(props.widgets[i]);
        }
      }
      if (!existe) {
        newWidgets = [request.data.data.widget[0]].concat(newWidgets);
      }
      props.changeWidgets(newWidgets);
    }
    props.changeLoader(false);
  };

  const block = async () => {
    if (!content.hasOwnProperty("uuid")) {
      return;
    }

    props.changeLoader(true);
    let request = await API.service('openModalBlockCustomer', props.content.uuid, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == 'OK') {
      let catalog = request.data.data.widget[0].content.catalog
      const as = (
        <CustomerBlockUnblock
          data={content}
          pos={props.pos}
          changeAlert={props.changeAlert}
          changeLoader={props.changeLoader}
          customerUuid={props.content.uuid}
          catalogs={catalog}
          blocked={blocked}
          setBlocked={setBlocked}
          changeStatus={changeStatus}
          reloadData={reloadData}
          key="customerBlockUnblock"
        />
      );
      openlightbox(as);
    }
    props.changeLoader(false);
  };

  const blockUnblock = async () => {
    const b = !blocked;
    let data = {
      customer: {
        uuid: content["uuid"],
      },
      action: b ? "block" : "unblock",
    };

    props.changeLoader(true);
    let request = await API.service("customerBlockUnblock", data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == "OK") {
      let d = props.content;
      d.status = "enabled";
      changeStatus(d);
      setBlocked(b);
      await reloadData(d.uuid)
      props.changeAlert(true, "success", "Datos actualizados con éxito");
    }
    props.changeLoader(false);
  };

  const updateAgreements =  async(agrementsData:IAgreementsUpdatePayload[])=>{
    const data = {
    owner: {
        entity_uuid:content['uuid']
    },
    agreements: agrementsData,
    email:content['email'],
    status:content['status']
    }
    let request = await API.service("agreementsUpdate",data,props.pos,props.changeAlert,props.changeLoader,history);

    if (request.status == 200 && request.data.data.response == 'OK') {
      props.changeLoader(false);
      props.changeAlert(true, "success", "Se ha generado el contrato con exito!");
    }
  }
  const agreements = async ()=>{
    const data = {
        owner: {
            entity_uuid:content["uuid"]
        },
        is_new_customer: false,
        type_agreement: "all"
    }
    props.changeLoader(true);
    let request = await API.service("agreementsGet",data,props.pos,props.changeAlert,props.changeLoader,history);
    let result = request.data.data.result.data;
    if (request.status == 200 && request.data.data.response == 'OK') {
      dialogProps.openDialog();
      const as = (
        <Agreements
          title={'Contratos'}
          onClose={onCloseDialog} 
          changeLoader={props.changeLoader}
          open={true}
          changeAlert={props.changeAlert}
          tab="widget"
          roles={rolesType}
          menu={menuType}
          date={props.content['validation_date']}
          categoryMenu={categoryMenu}
          data={result}
          onConfirm={updateAgreements}
        />
      );
      openlightbox(as)
    }
    props.changeLoader(false);
  }

  const onHandleValidateProducts = async (uuid) => {
    props.changeLoader(true);

    let request = await API.service('findEnabledSpaces', uuid, props.pos, props.changeAlert, props.changeLoader, history);
    if(request.status == 200 && request.data.data.response == 'OK'){
      let widg = request.data.data.content;
      if (widg.length > 0) {
        props.changeAlert(true, 'error', 'El Cliente seleccionado tiene Espacios activos, debes cancelarlos para continuar.');
        return false;
      } else {
        return true;
      }
    }
    props.changeLoader(false);
  }

  const cancel = async () => {
    if (!content.hasOwnProperty("uuid")) {
      return;
    }
    props.changeLoader(true);
    const validate = await onHandleValidate(props.content.uuid);
    const validateProducts = await onHandleValidateProducts(props.content.uuid);

    if(validate && validateProducts){
      let request = await API.service('openModalCancelCustomer', props.content.uuid, props.pos, props.changeAlert, props.changeLoader, history);
      if (request.status == 200 && request.data.data.response == 'OK') {
        let catalog = request.data.data.widget[0].content.catalog
  
        const as = (
          <CustomerCancel
            data={content}
            pos={props.pos}
            changeAlert={props.changeAlert}
            changeLoader={props.changeLoader}
            customerUuid={props.content.uuid}
            catalogs={catalog}
            setBlockCancel={setBlockCancel}
            changeStatus={changeStatus}
            reloadData={reloadData}
            key="customerCancel"
          />
        );
        openlightbox(as);
      }
    }
    props.changeLoader(false);
  };

  const changeStatus = (item) => {
    let d = [content];
    for (let i = 0; i < d.length; i++) {
      if (item.uuid == d[i]["uuid"]) {
        d[i]["status"] = item.status;
      }
    }
    props.content.status = d[0].status;
  };

  const getCuentaTypeFormat = (type) => {

    switch (type) {
      case "1": {
        return "Cliente Normal";
      }
      case "2": {
        return "Card in Hand";
      }
      case "3": {
        return "Empresa"; 
      }
      case "4": {
        return "PFAE";
      }
      default: {
        return "N/A";
      }
    }
  };

  const resetIntents = async (uuid) => {
    props.changeLoader(true);
    let data = {
      customer: {
        uuid: uuid
      }
    }
    let request = await API.service('resetIntents', data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == 'OK') {
      props.changeAlert(true, 'success', 'Se reinicio el contador de intentos');
    }
    props.changeLoader(false);

  }

  const openModalReject = async (item) => {
    props.changeLoader(true);

    let request = await API.service('openModalReject', item.uuid, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == 'OK') {
      let contentModal = {
        title: item.name,
        status: props.content.manualCheck,
        content: request.data.data.widget[0].content,
      };
      const as = (
        <Modals.OpenModalReject
          changeAlert={props.changeAlert}
          changeLoader={props.changeLoader}
          pos={props.pos}
          contentModal={contentModal}
          key="openModalReject"
        />
      );
      openlightbox(as);
    }
    props.changeLoader(false);
  };

  const findValidations = async () => {
    props.changeLoader(true);
    let data = {
      name: props.content.name,
      uuid: content['uuid'],
      page: 1,
      limit: 5
    }

    let request = await API.service('findValidations', data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == 'OK') {
      let newWidgets = [];
      let existe = false;
      for (let i = 0; i < props.widgets.length; i++) {
        if (props.widgets[i]["type"] == "validationsList") {
          newWidgets.push(request.data.data.widget[0]);
          existe = true;
        } else {
          newWidgets.push(props.widgets[i]);
        }
      }

      if (!existe) {
        newWidgets = [request.data.data.widget[0]].concat(newWidgets);
      }
      props.changeWidgets(newWidgets);
    }
    props.changeLoader(false);
  }

  const getCatalog = async () => {
    props.changeLoader(true);
    let data = {
      catalog: {
        id: "customer_limits",
      },
    };
    
    let request = await API.service('getCatalog', data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == 'OK') {
      setCatalogLevel(request.data.data.catalog)
      setUpgrade(true)
    }
    props.changeLoader(false);
  }

  const levelUpgrade = async (e) => {
    props.changeLoader(true);
    
    let data = {
      entity: {
        uuid: content["uuid"],
        type: "customer"
      },
      new_space_level : {
        profile : e.target.value,
        type : "1"
      }
    };

    const infocuenta = props.widgets.filter((i) => {
      if(i.type === "infoCuenta" && i["content"][0]["uuid"]){
        return i
      }
    }) 

    const dataCuenta = {
      entity: {
        uuid: infocuenta[0]["content"][0]["uuid"],
        type: "space_account"
      },
      new_space_level : {
        profile : e.target.value,
        type : "1"
      }
    }

    let request = await API.service('spaceLevelUpgrade', data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == 'OK' ) {
      let requestCuenta = await API.service('spaceLevelUpgrade', dataCuenta, props.pos, props.changeAlert, props.changeLoader, history);
      setUpgrade(false)
      if (requestCuenta.status == 200 && requestCuenta.data.data.response == 'OK') {
        setLevel(data.new_space_level.profile)
        await reloadData(content["uuid"])
        props.changeAlert(true, 'success', 'Nivel de cuenta actualizado con éxito');
      }
    }
    setUpgrade(false)
    props.changeLoader(false);
  }

  const openRiskLevelUpdate = (item) => {
      let options = [
        { label: 'Alto', key: 'Alto' },
        { label: 'Medio', key: 'Medio' },
        { label: 'Bajo', key: 'Bajo' },
      ]

      setItem({
        customer: item.corporate_name,
        uuid: item.uuid,
        risk_level: item.risk,
      })
      setElement([
          {type: "select", options: options, label: "Riesgo", key: "risk_level", text: "A continuación selecciona el nuevo Nivel."}
      ]);
      setDialogText({
          title: "Actualización de Nivel de Riesgo",
          message: "¿Estás seguro que deseas editar el nivel de éste Cliente?"
      });
      dialogRisk.openDialog();
  };

  const onHandleConfirm = async (result) => {
      dialogRisk.onClose();

      props.changeLoader(true);
      let data = {
        uuid: result["uuid"],
        risk_level: result["risk_level"],
      }
  
      let request = await API.service( "afbRiskLevelUpdate", data, props.pos, props.changeAlert, props.changeLoader, history );
      if (request.status === 200 && request.data.data.response === "OK") {
        props.changeAlert(true, "success", "El cliente se actualizó con éxito.");
        await reloadData(data.uuid);
      } else {
        let detail = request.data.data.message;
        props.changeAlert(true, "error", "Error al ejecutar la acción: " + detail);
        props.changeLoader(false);
      }
  };

  const onGetSegments = async () => {
      let payload = {
        catalog: {
          id: 'customer_segments',
          filters: [{ 'metadata.external.origin': 'afb' }],   
        }
      }

      let request = await API.service('getCatalog', payload, props.pos, props.changeAlert, props.changeLoader, history);
      if (request.status == 200 && request.data.data.response == 'OK') {
        let catalog = request.data.data.catalog
        setSegments(catalog);
      }
  }
  const onGetCompanyGroups = async () => {
      let payload = {
          filters: { all: true }
      }

      let request = await API.service('leadCrmGroupList', payload, props.pos, props.changeAlert, props.changeLoader, history);
      if (request.status == 200 && request.data.data.response == 'OK') {
        let catalog = request.data.data.widget[0].data.content
        setCompanyGroups(catalog);
      }
  }

  const onUpdateCrmData = async () => {
    props.changeLoader(true);
    
    dialogProps.openDialog();
    const as = (
      <AfbUpdateCRM
        open={true}
        onClose={onCloseDialog}
        customer={props.content}
        segments={segments}
        companyGroups={companyGroups}
        crmData={props.content.crm_data}
        reloadData={reloadData}
        changeAlert={props.changeAlert}
        changeLoader={props.changeLoader}
        key="afbUpdateCRM"
      />
    );
    openlightbox(as);
      
    props.changeLoader(false);
  };

  const onCloseDialogConfirm = () => {
      dialogRisk.onClose();
  };

  const riskInfo = [
    { key: "Bajo", label: "rB" , css: "rec_b"},
    { key: "Medio", label: "rM" , css: "rec_s"},
    { key: "Alto", label: "rA" , css: "rec_ra"},
  ];

  const statusInfo = [
    { key: "enabled", label: "Activo" },
    { key: "disabled", label: "Inactivo" },
    { key: "blocked", label: "Bloqueado" },
    { key: "under_observation", label: "En observación" },
  ];

  const kycStatus = [
    { key: "profile", label: "Perfil Transaccional" },
    { key: "pep", label: "Cuestionario PEP" },
    { key: "risk_data", label: "KYC Complementario" },
    { key: "cash_data", label: "Cuestionario de Efectivo" },
  ];

  const data = [
    { key: "risk", label: "Nivel de Riesgo"},
    { key: props.content.origin == "albo.os.migration" ? "origin" : null, label: "Usuario", data: <b style={{ color: "#6CB156" }}>Migrado</b> },
    { key: "name", label: props.content.originAppUUID === "3" ? "Razón Social" : "Nombre", data: <b>{props.content.originAppUUID === "3" ? props.content.corporate_name : props.content.name}</b> },
    { key: props.content.originAppUUID === "3" ? "gname" : null, label: "Nombre Comercial", data: <b>{props.content.gname}</b> },
    { key: "uuid", label: "UUID" },
    { key: "gender", label: "Género", data: stateLabel.gender },
    { key: "bdate", label: `Fecha de ${props.content.originAppUUID === "3" ? "Constitución" : "Nacimiento"}`, data: props.content.bdate.hasOwnProperty("$date")
      ? moment(new Date(props.content.bdate.$date)).format("L")
      : moment(new Date(props.content.bdate.substring(0, 10).replace(/-/g, "/"))).format("L") },

    { key: props.content["vip"] ? hasFieldIn("vip") ? "email" : null : "email", label: "Email" },
    { key: props.content.originAppUUID === "3" ? "onboarding_email" : null, label: "Onboarding Email", data: props.content["onboarding_email"] || "No aplica" },
    { key: props.content.originAppUUID === "3" ? "charge_fee" : null, label: "Cobro de Fee", data: props.content["charge_fee"] + "%"  || "No aplica"},
    { key: props.content.originAppUUID === "3" ? "company_group" : null, label: "Grupo Empresarial", data: companyGroups?.find(item => item.uuid === props.content["company_group"])?.group_name  || "No aplica"},
    { key: props.content.originAppUUID === "3" ? "segment" : null, label: "Segmento", data: segments?.find(item => item.k === props.content["segment"])?.v  || "No aplica"},
    { key: "email_verify", label: "Confirmación de Correo" },
    { key: content.statusValidation == "rejected" ? "statusValidation" : null, label: "Motivo de Rechazo" },
    { key: "bcountry", label: `Lugar de ${props.content.originAppUUID === "3" ? "Constitución" : "Nacimiento"}`, data: country },
    { key: "dateCheck", label: "Fecha Check", data: props.content.dateCheck.hasOwnProperty("$date")
      ? moment(new Date(props.content.dateCheck.$date)).format("L")
      : moment(new Date(props.content.dateCheck.substring(0, 10).replace(/-/g, "/"))).format("L") },

    { key: props.content["vip"] ? hasFieldIn("vip") ? "phone" : null : "phone", label: "No. Celular" },
    { key: "occupation", label: "Ocupación", data: ocupacion },
    { key: "taxid", label: "RFC", copy: hasField("taxExist") ? false : true, data: hasField("taxExist") ? props.content.taxid ? "Si" : "No" : <a target="_blank" rel="noopener noreferrer" href="https://agsc.siat.sat.gob.mx/PTSC/ValidaRFC/index.jsf">{props.content.taxid}</a> },
    { key: "populationid", label: "CURP", copy: hasField("taxExist") ? false : true, data: hasField("populationExist") ? props.content.populationid ? "Si" : "No" : <a target="_blank" rel="noopener noreferrer" href="https://www.gob.mx/curp/">{props.content.populationid}</a>},
    { key: "status", label: "Estatus", data: statusInfo.map((i) =>{if(i.key === props.content.status){return i.label}}) },
    { key: props.content.status_original ? "status_original" : null, label: "Estatus Legacy", data: "Waiting for albo Card"},
    { key: props.content.status == "blocked"  &&  props.content.reasonBlock ? "reasonBlock" : null, label: "Motivo de Bloqueo", data: props.content.reasonBlock ? props.content.reasonBlock.map((item, index) => {return <p key={`reasonBlock-${index}`}>{item}</p> }) : [], change: true },
    { key: props.content.status == "blocked"  &&  props.content.commentBlock ? "commentBlock" : null, label: "Comentario de Bloqueo", data: props.content.commentBlock ? <p>{props.content.commentBlock}</p> : [], change: true },
    { key: props.content.status == "disabled"  &&  props.content.reasonCancel ? "reasonCancel" : null, label: "Motivo Cancelación", data: props.content.reasonCancel ? props.content.reasonCancel.map((item, index) => {return <p key={`reasonCancel-${index}`}>{item}</p> }) : [], change: true },
    { key: props.content.status == "disabled"  &&  props.content.commentCancel ? "commentCancel" : null, label: "Comentario Cancelación", data: props.content.commentCancel ? <p>{props.content.commentCancel}</p> : [], change: true },
    { key: "typeIdentity", label: "Identificación", data: (roles.indexOf("inext-role-compliance-analyst") > -1 || roles.indexOf("inext-role-compliance-manager") > -1 || roles.indexOf("inext-role-IT-Ops") > -1) ? (
      props.content.typeIdentity !== "Sin Documentos" ? <a id="identity-link" href="#" onClick={addIdentity.bind(this, props.content.uuid)}>{props.content.typeIdentity}</a> : props.content.typeIdentity) 
        : false },
    { key: "originAppUUID", label: "Tipo de Cuenta", data: getCuentaTypeFormat(props.content.originAppUUID)},
    { key: "manualCheck", label: "Validación Manual", data: hasAction("openReject") && (props.content.manualCheck === "Rechazado" || props.content.manualCheck === "invalidated") ? <a id="identity-link"  href="#" onClick={() => openModalReject(props.content)}>{props.content.manualCheck}</a> : null },
    { key: props.content.hasOwnProperty("pep") ? "pep" : null, label: "PEP", data:  props.content.pep ? "Si" : "No" },
    { key: "onboarding_type", label: "Onboarding", data: props.content.onboarding_type },
    { key: "legal_agreements", label: "Contrato Firmado", data: props.content.legal_agreements?.completed ? "Si" : "No" },
  ];

  const watchlist = []
  watchlist.push({ key: "watchlist_url", label: "Watchlist", data: (props.content.watchlist_url !== 'N/A' && props.content.watchlist_url?.indexOf('http') > -1 ) ? <a href={props.content.watchlist_url} target="_blank" rel="noopener noreferrer">Comply Advantage</a> 
    : props.content?.watchlist_url && props.content?.watchlist_url?.indexOf('http') == -1 && <span>{props.content.watchlist_url}</span>})

  if(typeof(props.content.watchlist) === "string"){
    watchlist.push([
      { key: "watchlistId", label: "Watchlist", data: props.content.watchlist ? props.content.watchlist : "N/A" },
    ]) 
  }

  if(Array.isArray(props.content.watchlist)){
    props.content.watchlist?.map((i, index) => {
      return [
        watchlist.push([
          { key: "watchlistId", label: "Id Watchlist", data: props.content.watchlist[index]["id"] },
          { key: "total_matches", label: "Total", data: props.content.watchlist[index]["total_matches"] },
          { key: "match_status", label: "Estatus", data: props.content.watchlist[index]["match_status"] },     
          i["hits"]?.map((hits) => {            
            return [
              { key: "hits_doc_id", label: "Id de documento", data: hits.id },
              { key: "hits_match_types", label: "Tipos", data: hits.match_types ? hits.match_types.map((item, index) => {return <p key={`match-${index}`}>{item}</p> }) : [], change: true },
              { key: "hits_doc_sources", label: "Origen", data: hits.sources ? hits.sources.map((item, index) => {return <p key={`sources-${index}`}>{item}</p> }) : [], change: true },
              { key: "hits_doc_types", label: "Tipos de documentos", data: hits.types ? hits.types.map((item, index) => {return <p key={`types-${index}`}>{item}</p> }) : [], change: true },
            ]    
          })
        ]),  
      ]    
    })
  } else {
    if(props.content?.watchlist && Object.keys(props.content.watchlist).length > 0){
      watchlist.push([
        { key: "watchlistId", label: "Id Watchlist", data: props.content.watchlist["id"]},
        { key: "total_matches", label: "Total", data: props.content.watchlist["total_matches"]},
        { key: "match_status", label: "Estatus", data: props.content.watchlist["match_status"]},     
        
        props.content.watchlist["hits"]?.map((hits) => {
          return [
            { key: "hits_doc_id", label: "Id de documento", data: hits.id },
            { key: "hits_match_types", label: "Tipos", data: hits.match_types ? hits.match_types.map((item, index) => {return <p key={`match-${index}`}>{item}</p> }) : [], change: true },
            { key: "hits_doc_sources", label: "Origen", data: hits.sources ? hits.sources.map((item, index) => {return <p key={`sources-${index}`}>{item}</p> }) : [], change: true },
            { key: "hits_doc_types", label: "Tipos de documentos", data: hits.types ? hits.types.map((item, index) => {return <p key={`types-${index}`}>{item}</p> }) : [], change: true },
          ]    
        })
      ])
    }
  }

  const allow = [ "populationid",  "taxid", "origin", "originAppUUID", "manualCheck", "onboarding_type", "legal_agreements", "pep", "risk"]

  const listWatch = (i) => {
    return (  
      <div key={`listWatch-${i.key}`} className="dataBlockItem">
        <label className="neutral">{i.label}</label>
        {!i.change ? 
          <p>{i.data || props.content[i.key] || "N/A"}       
            {i["copy"] && <Tooltip title={"Copiar"} sx={{padding: 0, visibility: show ? "hidden" : "visible" }} componentsProps={{tooltip: {sx: {backgroundColor: '#3743AA'}}}}>
              <IconButton sx={{padding: 0}} onClick={copy.bind(this, props.content[i.key])}>
                <FileCopyOutlinedIcon sx={{fontSize: "initial"}}/>
              </IconButton>
            </Tooltip>}
          </p>
          : <div className="item_personal">{i.data || props.content[i.key] || "N/A"}</div>
        }              
      </div>
    )
  }

  const sendRequestSnack = async (data, action, message) => {
    props.changeLoader(true);
    let request = await API.service(action, data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == 'OK') {
      props.changeAlert(true, 'success', message);
    }
    props.changeLoader(false);
  }

  const syncTpa = async  (op, uuid) => {
    let data = {
      data: {
        op: op,
        customer: {
          uuid: uuid
        }
      }
    }

    await sendRequestSnack(data, 'syncTpa', op == 'create-info' ? 'Información creada con exito' : 'Documentos creados con exito');
  }
  
  const selectLevel = () => {
    return (
      <select style={{width: "33%"}} value={""} onChange={levelUpgrade.bind(this)} >
        <option label={level} value={''} disabled hidden></option>
        {catalogLevel.map((item, index) => {
          if(!(item.v.includes("loan"))){
            return <option key={`level-${index}`} value={item.k}>
              {item.k}
            </option>
          }})
        }
      </select>
    )
  }

  return (
    <div className="size-6 dataBlock">
      <div className="card">
        <Typography
          component="div"
          children={
            <div className={clasess.titleTable}>
              <h2 className={clasess.titleH2}>
                <Person className={clasess.iconTitle} />
                Datos personales
              </h2>
              <div className={`col-7 row ${clasess.headOptions}`}>
              {hasAction("block") && props.content.status !== "disabled" && (                
                <Tooltip title={props.content.status === "blocked" || blocked ? 'Desbloquear' : 'Bloquear'} color="secondary" style={{top: "22px"}}>
                  <div className={`switcherB mini desktop ${props.content.status === "blocked" || blocked  ? "active" : "" }`} style={{alignSelf: "center"}}
                    onClick={ props.content.status === "blocked" || blocked ? blockUnblock : block }>
                    <div className="switcherBSlider">
                      <div className="switcherBSliderCircle" />
                    </div>
                  </div>
                </Tooltip>
              )}
              {hasAction("agreements") && props.content.status !== "disabled" && (
              <Tooltip title="Generar Contratos Genericos">
                <IconButton onClick={!blockCancel ? agreements : null}>
                  <Description/>
                </IconButton>
              </Tooltip>
              )}
              {hasAction("cancel") && props.content.status !== "disabled" && (
                <Tooltip title="Cancelar">
                  <IconButton onClick={!blockCancel ? cancel : null}>
                    <Cancel/>
                  </IconButton>
                </Tooltip>
              )}
              {hasAction('reset') &&
                <Tooltip title="Reset intentos">
                  <div>
                  <IconButton disabled={!blockCancel ? false : true} onClick={resetIntents.bind(this, props.content.uuid)}>
                    <Restore/>
                  </IconButton>
                  </div>
                </Tooltip>
              }
              {hasAction("download") && (
                <Tooltip title="Descargar">
                  <IconButton onClick={download.bind(this, props.content.uuid, props.content.originAppUUID)}>
                    <Download/>
                  </IconButton>
                </Tooltip>
              )}
              {hasAction("levelUpgrade") && (
                <Tooltip title="Nivel de Cuenta">
                  <IconButton onClick={getCatalog.bind(this)}>
                    <TrendingUp />
                  </IconButton>
                </Tooltip>
              )}
              {hasAction("edit") && (
                <Tooltip title="Editar">
                  <IconButton onClick={validation.bind(this, props.content, 'infoPersonal')}>
                    <Edit/>
                  </IconButton>
                </Tooltip>
              )}
              {
                hasAction('createInfo') &&
                <Tooltip title="Crear Información">
                  <IconButton onClick={syncTpa.bind(this, 'create-info', props.content.uuid)}>
                    <PostAdd/>
                  </IconButton>
                </Tooltip>
              }
              {
                hasAction('createFile') &&
                <Tooltip title="Crear Archivos">
                  <IconButton onClick={syncTpa.bind(this, 'create-files', props.content.uuid)}>
                    <NoteAdd/>
                  </IconButton>
                </Tooltip>
              }
              {
                hasAction('dataReuse') && props.content.status === "disabled" && !props.content.email.includes('_REUSADO') &&
                <Tooltip title="Liberar datos">
                  <IconButton onClick={dataReuse.bind(this, props.content.uuid)}>
                    <ContactPageSharp/>
                  </IconButton>
                </Tooltip>
              }
              {
                hasAction('resetPin') && (type === 'n1' || type === 'n3') &&
                <Tooltip title="Reset contraseña">
                  <IconButton onClick={resetPin.bind(this, props.content)}>
                    <LockReset/>
                  </IconButton>
                </Tooltip>
              }
              {
                config['afbOps'] &&
                hasAction('updateCRM') && props.content.originAppUUID === "3" &&
                <Tooltip title="Actualizar CRM">
                  <IconButton onClick={onUpdateCrmData.bind(this, props.content)}>
                    <Store/>
                  </IconButton>
                </Tooltip>
              }
            </div>
          </div>
        }
        />

      {/* Content --------------------------------- */}
      <div className={`dataBlock ${clasess.block}`}>
        {data.map((i) => { 
          if(content[i.key] || allow.includes(i.key) ){
            switch (i.key) {
                case "risk":
                  if(props.content.subproduct_uuid){
                    return (
                      <div key={`subproduct-${i.key}`} className={`dataBlockItem ${clasess.pnl_type}`}>
                        <label className="neutral">
                          {riskInfo.map((i, index) => {
                            if(props.content.risk === i.key){
                              return (
                                <div key={`risk-${index}`} className={`tooltip ${i.css}`} style={{cursor: hasAction('updateRisk') && props.content.originAppUUID === "3" ? "pointer" : "default"}} onClick={hasAction('updateRisk') && props.content.originAppUUID === "3" ? () => openRiskLevelUpdate(props.content) : null}>
                                  <span className="tooltiptext tooltip-bottom">Riesgo {i.key}</span>
                                  {i.label}
                                </div>
                              )
                            }
                          })}
                          <div key={`level-${i.key}`} className="tooltip rec_n4"> 
                            <span className="tooltiptext tooltip-bottom">Nivel de cliente</span> 
                            {props.content.subproduct_uuid ? props.content.subproduct_uuid.replace('key-debit-', '') : ''}
                          </div>
                        </label>
                        {upgrade && selectLevel()}
                      </div>
                    )
                  } else {
                    return (props.content.risk &&
                      <div key={`subproduct-${i.key}`} className={`dataBlockItem ${clasess.pnl_type}`}>
                        <label className="neutral">
                          {riskInfo.map((i, index) => {
                            if(props.content.risk === i.key){
                              return (
                                <div key={`risk-${index}`} className={`tooltip ${i.css}`}>
                                  <span className="tooltiptext tooltip-bottom">Riesgo {i.key}</span>
                                  {i.label}
                                </div>
                              )
                            }
                          })}
                        </label>
                      </div>
                    )
                  }
              case "email":
                return (
                  <div key={`email-${i.key}`} className="dataBlockItem">
                    <label className="neutral">{i.label}</label>
                    <section id="copyEmail" style={{alignItems: "center"}}>{props.content.email}
                      <Tooltip title={"Copiar"} sx={{padding: 0, visibility: show ? "hidden" : "visible" }} componentsProps={{tooltip: {sx: {backgroundColor: '#3743AA'}}}}>
                        <IconButton sx={{padding: 0}} onClick={copy.bind(this, props.content.email)}>
                          <FileCopyOutlinedIcon sx={{fontSize: "initial"}}/>
                        </IconButton>
                      </Tooltip>   
                    </section>
                  </div>
                )  
              default:
                return listWatch(i)
            }
          }
        })}

        {hasAction('viewValidations') &&
          <div className="dataBlockItem">
            <label className="neutral">Validaciones Manuales</label>
            <a id="identity-link" href="#" onClick={findValidations.bind(this)}>
              Ver listado
            </a>
          </div>
        }      

        {watchlist.map((i, index) => {
          if(i){
            if(Array.isArray(i)){
              return <div key={`watchlist-${index}`}>              
                <div>
                  <hr /><p style={{padding: 0}}>Coincidencias</p><br />
                </div>
              {i.map((j) => {

                if(j){
                  if(Array.isArray(j) && j){
                    return j.map((k) => {
                      return k.map((l) => {
                        return listWatch(l)
                      })
                    })
                  } else {
                    return listWatch(j)
                  }
                }
              })}
              </div>
            } else {
              return listWatch(i)
            }
          }
        })}

        <div>
          <hr /><p style={{padding: 0}}>Estatus de Cuestionario</p><br />
          {kycStatus.map((s) => {
            return (    
              <div key={`kycStatus-${s.key}`} className="dataBlockItem">
                <label className="neutral">{s.label}</label>
                <p>{props.content.kyc && props.content.kyc[s.key] ? props.content.kyc[s.key]?.status === "completed" ? "Completado" : "En proceso" : "N/A"}</p>
              </div>
            )
          })}
        </div>

        {props.content.hasOwnProperty("not_match_mirai") && 
          <div className={'tabBoxContainer not_match'}>
          <hr/>
          <p style={{display: "flex"}}>
            <ErrorOutline fontSize='small' style={{marginRight: "5px",}} />
            <span>Campos existentes solo en Legacy</span>
          </p>
          { props.content["not_match_mirai"].fields.map((i) => {
            return (
              legacy.map((l) => {
              if(i === l.key){
                return <label key={`legacy-${i}`}>{l.label}</label>
              }
            }))
          })}
          </div>
        }
        </div>
      </div>
      <SimpleSnackbar 
        show={show}
        message={"Copiado"}
        duration={1000}
      />

      <GeneralConfirmDialog 
          open={dialogRisk.open}
          text={dialogText}
          onClose={onCloseDialogConfirm} 
          onConfirm={onHandleConfirm.bind(this)} 
          item={item}
          element={element}
      />
    </div>
  );
};

export default InfoPersonal;
